import { lazy } from "react";
import { Navigate, useLocation, Route } from "react-router-dom";
import MerchantLayout from "src/_modules/layouts/Merchant";
import LazyRouteWrapper from "../LazyRouteWrapper";
const Dashboard = lazy(() => import("src/views/MerchantDashboard"));
const LanguageSetting = lazy(() => import("src/modules/Settings/LanguageSetting"));
const WhatsappMessagesSettings = lazy(() => import("src/modules/Settings/WhatsappMessagesSettings"));
const ZoneOrderList = lazy(() => import('src/modules/Order/ZoneOrderList'));
const OrderList = lazy(() => import("src/modules/Order/OrderList"));
const AddOrder = lazy(() => import('src/modules/Order/OrderManagement'));
const OrderDetails = lazy(() => import("src/modules/Order/OrderDetails"));
const DriverList = lazy(() => import('src/_modules/Users/Driver/DriverList'));
const AddDriver = lazy(() => import('src/_modules/Users/Driver/DriverManagement'));
const DriverDetails = lazy(() => import("src/_modules/Users/Driver/DriverDetails"));
const ZoneList = lazy(() => import("src/views/ZoneList"));
const Integrations = lazy(() => import('src/views/Integrations/Integrations'));
// const ZIDIntegrationCheckStatus = lazy(() => import('src/views/Integrations/ZIDIntegrationCheckStatus'));
// const ZIDIntegrationRedirect = lazy(() => import('src/views/Integrations/ZIDIntegrationRedirect'));
const TrackDrivers = lazy(() => import("src/_modules/Users/Driver/TrackDrivers"));
const Connection = lazy(() => import("src/modules/Connection"));
const Warehouse = lazy(() => import("src/modules/Warehouse"));
const SubscriptionManagement = lazy(() => import("src/views/SubscriptionManagement"));
const WarehouseGuard = lazy(() => import("src/_modules/Guard/GuardManagements"));
const MerchantCreateTask = lazy(() => import("src/_modules/Tasks/Merchant/MerchantCreateTask"));
const MerchantTasksList = lazy(() => import("src/_modules/Tasks/Merchant/MerchantTasksList"));
const MerchantZonesTasksCount = lazy(() => import("src/_modules/Tasks/Merchant/MerchantZonesTasksCount"));
const TasksDashboard = lazy(() => import("src/_modules/Tasks/Merchant/TasksDashboard"));
const AccountPlans = lazy(() => import("src/_modules/Account/AccountPlans"));
const AccountSubscription = lazy(() => import("src/_modules/Account/AccountSubscription"));
const MerchantAccountBasicInfo = lazy(() => import("src/_modules/Account/MerchantAccountBasicInfo"));
const MerchantAccountSettings = lazy(() => import("src/_modules/Account/MerchantAccountSettings"));
const PlanCheckout = lazy(() => import("src/_modules/Account/PlanCheckout"));
const Customizations = lazy(() => import("src/_modules/Customizations/Customizations"));
const Users = lazy(() => import("src/_modules/Users/Users/Users"));
const Profile = lazy(() => import("src/_modules/Users/Profile"));
const Transactions = lazy(() => import("src/_modules/Transactions"));
const MapitShipOrders = lazy(() => import("src/_modules/MapitShip/views/MapitShipOrders"));
const ShipmentsPriceCalculateAndSelectShippingCompany = lazy(() => import("src/_modules/MapitShip/views/PriceCalculator/ShipmentsPriceCalculateAndSelectShippingCompany"));
const AccountBalance = lazy(() => import("src/_modules/MapitShip/views/AccountBalance"));
const Boxes = lazy(() => import("src/_modules/MapitShip/views/Boxes"));
const PriceCalculator = lazy(() => import("src/_modules/MapitShip/views/PriceCalculator/PriceCalculator"));
const ShipmentPriceCalculator = lazy(() => import("src/_modules/MapitShip/views/PriceCalculator/ShipmentPriceCalculator"));
const CodInvoices = lazy(() => import("src/_modules/MapitShip/views/CodInvoices"));
const NotFound = lazy(() => import("src/_modules/common/NotFound"));
const ShippingPartnersList = lazy(() => import("src/modules/Admin/ShippingPartners/ShippingPartnersList"));
const ZoneOrdersCount = lazy(() => import("src/_modules/Tasks/ShippingCompany/ZoneOrdersCount"));
const ZoneOrders = lazy(() => import("src/_modules/Tasks/ShippingCompany/ZoneOrders"));
const EditTask = lazy(() => import("src/_modules/Tasks/ShippingCompany/EditTask"));
const TaskDetails = lazy(() => import("src/_modules/Tasks/ShippingCompany/TaskDetails"));
const OrdersList = lazy(() => import("src/_modules/Tasks/ShippingCompany/OrdersList"));
const ZonesTasksCount = lazy(() => import("src/_modules/Tasks/ShippingCompany/ZonesTasksCount"));
const ZoneTasksList = lazy(() => import("src/_modules/Tasks/ShippingCompany/ZoneTasksList"));
const TaskOrderDetails = lazy(() => import("src/_modules/Tasks/ShippingCompany/OrderDetails"));
const TasksList = lazy(() => import("src/_modules/Tasks/ShippingCompany/TasksList"));
const TasksCount = lazy(() => import("src/_modules/Tasks/ShippingCompany/TasksCount"));
// const RecentTasks = lazy(() => import("src/_modules/Tasks/TasksFilter/RecentTasks"));
const ReturnedTasks = lazy(() => import("src/_modules/Tasks/ShippingCompany/ReturnedTasks"));
const Orders = lazy(() => import("src/modules/Order/Orders"));
const OrdersDashboard = lazy(() => import("src/modules/Order/OrdersDashboard"));
const NewOrdersList = lazy(() => import("src/modules/Order/OrdersDashboard/OrdersList"));
const NationalAddressTransactions = lazy(() => import("src/_modules/NationalAddressTransactions"));
const AramexSatchels = lazy(() => import("src/_modules/AramexSatchels"));
const IntegrationsGuide = lazy(() => import('src/views/IntegrationsGuide'));
const AdminOrdersFilter = lazy(() => import("src/modules/Order/OrdersFilter/AdminOrdersFilter"));
const AdminTasksFilter = lazy(() => import("src/_modules/Tasks/TasksFilter/AdminTasksFilter"));
const DriverStats = lazy(() => import("src/_modules/Users/Driver/DriversStats"));
const MapitShipProducts = lazy(() => import("src/_modules/Products"));

const CheckBeforeEnterMerchant = (currentUser) => {
    const location = useLocation()

    if (location.pathname !== "/" && currentUser?.merchant?.currentStatus === "BLOCKED") {
        return <Navigate to="/blocked" />
    } else if (currentUser) {
        return <MerchantLayout />
    }
    if (location.pathname === "/merchant/integrations/zid") {
        return <Navigate to="/auth/general?redirect_url=/merchant/integrations/zid" />
    }
    return <Navigate to="/auth/general" />
}

const CheckBeforeEnterAllOrders = (currentUser) => {
    const location = useLocation()

    const isMapitShipOnly = currentUser?.merchant?.deliveryMethod?.length === 1 && currentUser?.merchant?.deliveryMethod?.includes("MAPIT_SHIP")
    if (location.pathname === "/merchant/all-orders/zone" && isMapitShipOnly) {
        return <Navigate to="/merchant/all-orders/list?orderStatus=UNASSIGNED&type=PICK_UP" />
    }

    return <LazyRouteWrapper><OrdersDashboard /></LazyRouteWrapper>
}

const merchantRoutes = (currentUser) => (
    <>
        <Route path="merchant" element={CheckBeforeEnterMerchant(currentUser)}>
            <Route path="" element={<LazyRouteWrapper><Dashboard /></LazyRouteWrapper>} />
            <Route path="orders">
                <Route path="" element={<LazyRouteWrapper><ZoneOrderList /></LazyRouteWrapper>} />
                <Route path="list" element={<LazyRouteWrapper><OrderList /></LazyRouteWrapper>} />
                <Route path="add" element={<LazyRouteWrapper><AddOrder /></LazyRouteWrapper>} />
                <Route path=":id" element={<LazyRouteWrapper><OrderDetails /></LazyRouteWrapper>} />
                <Route path="completed-orders" element={<LazyRouteWrapper><Orders /></LazyRouteWrapper>} />
                <Route path="filter" element={<LazyRouteWrapper><AdminOrdersFilter key="orders-filter" /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="all-orders" element={CheckBeforeEnterAllOrders(currentUser)}>
                <Route path="zone" element={<LazyRouteWrapper><ZoneOrderList /></LazyRouteWrapper>} />
                <Route path="list" element={<LazyRouteWrapper><NewOrdersList /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="all-tasks" element={<LazyRouteWrapper><TasksDashboard /></LazyRouteWrapper>}>
                <Route path="zone" element={<LazyRouteWrapper><MerchantZonesTasksCount /></LazyRouteWrapper>} />
                <Route path="list" element={<LazyRouteWrapper><MerchantTasksList /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="tasks">
                <Route path="create" element={<LazyRouteWrapper><MerchantCreateTask /></LazyRouteWrapper>} />
                <Route path="filter" element={<LazyRouteWrapper><AdminTasksFilter /></LazyRouteWrapper>} />
                <Route path="zones" element={<LazyRouteWrapper><ZonesTasksCount /></LazyRouteWrapper>} />
                <Route path="zone_tasks/:zoneId" element={<LazyRouteWrapper><ZoneTasksList /></LazyRouteWrapper>} />
                <Route path="completed" element={<LazyRouteWrapper><TasksList /></LazyRouteWrapper>} />
                <Route path=":taskId" element={<LazyRouteWrapper><TaskDetails /></LazyRouteWrapper>} />
                <Route path="archived/:taskId" element={<LazyRouteWrapper><TaskDetails /></LazyRouteWrapper>} />
                <Route path="edit/:taskId" element={<LazyRouteWrapper><EditTask /></LazyRouteWrapper>} />
                <Route path="tasks_count" element={<LazyRouteWrapper><TasksCount /></LazyRouteWrapper>} />
                <Route path="orders" element={<LazyRouteWrapper><OrdersList /></LazyRouteWrapper>} />
                <Route path="zone_orders_count" element={<LazyRouteWrapper><ZoneOrdersCount /></LazyRouteWrapper>} />
                <Route path="zone_orders" element={<LazyRouteWrapper><ZoneOrders /></LazyRouteWrapper>} />
                <Route path="order/:id" element={<LazyRouteWrapper><TaskOrderDetails /></LazyRouteWrapper>} />
                <Route path="archived/order/:id" element={<LazyRouteWrapper><TaskOrderDetails /></LazyRouteWrapper>} />
                <Route path="returned" element={<LazyRouteWrapper><ReturnedTasks /></LazyRouteWrapper>} />
                <Route path="shipping-company/:shippingCompanyId" element={<LazyRouteWrapper><MerchantTasksList /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="drivers">
                <Route path="add" element={<LazyRouteWrapper><AddDriver /></LazyRouteWrapper>} />
                <Route path="" element={<LazyRouteWrapper><DriverList /></LazyRouteWrapper>} />
                <Route path=":id" element={<LazyRouteWrapper><DriverDetails /></LazyRouteWrapper>} />
                <Route path="track" element={<LazyRouteWrapper><TrackDrivers /></LazyRouteWrapper>} />
                <Route path="stats" element={<LazyRouteWrapper><DriverStats /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="zones">
                <Route path="" element={<LazyRouteWrapper><ZoneList /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="qrcodes" element={<LazyRouteWrapper><Dashboard /></LazyRouteWrapper>} />
            <Route path="integrations" element={<LazyRouteWrapper><Integrations /></LazyRouteWrapper>} />
            <Route path="integrations/guide/:platform" element={<LazyRouteWrapper><IntegrationsGuide /></LazyRouteWrapper>} />
            {/* <Route path="integrations/zid" element={<LazyRouteWrapper><ZIDIntegrationRedirect /></LazyRouteWrapper>} />
            <Route path="integrations/zid-status" element={<LazyRouteWrapper><ZIDIntegrationCheckStatus /></LazyRouteWrapper>} /> */}
            <Route path="settings">
                <Route path="language" element={<LazyRouteWrapper><LanguageSetting /></LazyRouteWrapper>} />
                <Route path="whatsapp" element={<LazyRouteWrapper><WhatsappMessagesSettings /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="account">
                <Route path="" element={<Navigate to="info" />} />
                <Route path="info" element={<LazyRouteWrapper><MerchantAccountBasicInfo /></LazyRouteWrapper>} />
                <Route path="settings" element={<LazyRouteWrapper><MerchantAccountSettings /></LazyRouteWrapper>} />
                <Route path="plans" element={<LazyRouteWrapper><AccountPlans /></LazyRouteWrapper>} />
                <Route path="plan-checkout/:planId/:period" element={<LazyRouteWrapper><PlanCheckout /></LazyRouteWrapper>} />
                <Route path="subscription" element={<LazyRouteWrapper><AccountSubscription /></LazyRouteWrapper>} />
            </Route>
            <Route path="profile" element={<LazyRouteWrapper><Profile /></LazyRouteWrapper>} />
            <Route path="connections" element={<LazyRouteWrapper><Connection /></LazyRouteWrapper>} />
            <Route path="warehouse" element={<LazyRouteWrapper><Warehouse /></LazyRouteWrapper>} />
            <Route path="warehouse_guard" element={<LazyRouteWrapper><WarehouseGuard /></LazyRouteWrapper>} />
            <Route path="customizations" element={<LazyRouteWrapper><Customizations /></LazyRouteWrapper>} />
            <Route path="subscriptions" element={<LazyRouteWrapper><SubscriptionManagement /></LazyRouteWrapper>} />
            <Route path="users" element={<LazyRouteWrapper><Users /></LazyRouteWrapper>} />
            <Route path="transactions" element={<LazyRouteWrapper><Transactions /></LazyRouteWrapper>} />
            <Route path="mapit-ship">
                <Route path="shipments" element={<LazyRouteWrapper><MapitShipOrders /></LazyRouteWrapper>} />
                <Route path="products" element={<LazyRouteWrapper><MapitShipProducts /></LazyRouteWrapper>} />
                <Route path="shipments/price-calculator/:orderId" element={<LazyRouteWrapper><ShipmentPriceCalculator /></LazyRouteWrapper>} />
                <Route path="shipments/price-calculator/list" element={<LazyRouteWrapper><ShipmentsPriceCalculateAndSelectShippingCompany /></LazyRouteWrapper>} />
                <Route path="price-calculator" element={<LazyRouteWrapper><PriceCalculator /></LazyRouteWrapper>} />
                <Route path="boxes" element={<LazyRouteWrapper><Boxes /></LazyRouteWrapper>} />
                <Route path="aramex-satchels" element={<LazyRouteWrapper><AramexSatchels /></LazyRouteWrapper>} />
            </Route>
            <Route path="cod-invoices" element={<LazyRouteWrapper><CodInvoices /></LazyRouteWrapper>} />
            <Route path="balance" element={<LazyRouteWrapper><AccountBalance /></LazyRouteWrapper>} />
            <Route path="not-found" element={<LazyRouteWrapper><NotFound /></LazyRouteWrapper>} />
            <Route path="shipping-partners" element={<LazyRouteWrapper><ShippingPartnersList /></LazyRouteWrapper>} />
            <Route path="national-address-transactions" element={<LazyRouteWrapper><NationalAddressTransactions /></LazyRouteWrapper>} />
            <Route path="*" element={<Navigate to="/errors/404" />} />
        </Route>
    </>
)

export default merchantRoutes;
